import { ISvgProps, Svg } from '@components';
import { memo } from 'react';

export const HKSTPLogoIcon = memo<ISvgProps>((props, { className }) => (
  <Svg
    className={className}
    id="HKSTP"
    xmlns="http://www.w3.org/2000/svg"
    width="240"
    height="72"
    viewBox="0 0 240 72"
    {...props}
  >
    <rect
      id="Rectangle_6046"
      data-name="Rectangle 6046"
      width="240"
      height="72"
      transform="translate(0 0)"
      fill="none"
    />
    <g id="Group_17797" data-name="Group 17797" transform="translate(38.999 0)">
      <path
        id="Path_28147"
        data-name="Path 28147"
        d="M471.225,113.2a1.255,1.255,0,0,0-1.3.249.528.528,0,0,1-.715-.519A4.043,4.043,0,0,1,471.225,113.2Z"
        transform="translate(-313.444 -112.896)"
        fill="#848ea9"
      />
      <path
        id="Path_28148"
        data-name="Path 28148"
        d="M431.1,112.98a.528.528,0,0,0,.715.519,9.429,9.429,0,0,1,4.016,2.2.428.428,0,0,0,.54.249,4.015,4.015,0,0,1,.613,2.467,5.508,5.508,0,0,1-4.892,5.067.563.563,0,0,0-.3.165,69.382,69.382,0,0,0-10.029,13.624q-.137.249.154.491-1.311.361-.554.869a4.316,4.316,0,0,1,.561.431,4.833,4.833,0,0,0,1.034.764.182.182,0,0,0,.2.007.15.15,0,0,0,.067-.1.236.236,0,0,0-.074-.165A7.687,7.687,0,0,1,422,137.793a6.977,6.977,0,0,1,2.187,6.584,18.6,18.6,0,0,0,6.56,1.2,1.111,1.111,0,0,1,.364.07q.557.2.336-.333l.1-.424a.51.51,0,0,0-.953-.21.507.507,0,0,1-.512.235q-.364-.032-.406-.032a11.5,11.5,0,0,1-2.334-.168l.943-.035a.452.452,0,0,0,.3-.126,4.888,4.888,0,0,1,4.629-1.356l-1.23.07q-.224.011-.007.091a15.975,15.975,0,0,1,3.431,1.717,1.592,1.592,0,0,1,.322.319q.294.35.55-.067a4.2,4.2,0,0,1,.592,3.995,4.534,4.534,0,0,1-4.436,3.368,5.163,5.163,0,0,1-3.217-.936,4.79,4.79,0,0,1-1.868-3.094.452.452,0,0,0-.168-.28,15.66,15.66,0,0,0-3.406-2.053.324.324,0,0,0-.4.112,8.484,8.484,0,0,1-4.7,3.494.228.228,0,0,0-.165.224,50.449,50.449,0,0,0,.75,7.685l-.263.1a.23.23,0,0,0-.14.252l.96,6.486-1.945-.105a15.851,15.851,0,0,1-.189-2.856q.07-2.709.067-2.849l-.105-4.321q-.025-.88-.221-2.681a22.591,22.591,0,0,1-.133-2.7q.007-.876-.284-.5a.534.534,0,0,0-.088.322l0,2.541-.291,1.927-.161-3.052a.5.5,0,0,0-.41-.473,7.016,7.016,0,0,1-5.533-4.359,1.57,1.57,0,0,0,1.153.487q.785-.007.823,0a3.927,3.927,0,0,0,2.039-.308,4.349,4.349,0,0,1,2.926-.4.807.807,0,0,0,.242.028.378.378,0,0,0,.242-.074q.133-.137-.165-.214a3.754,3.754,0,0,0-1.5-.07q-.2.032-.018-.056a1.6,1.6,0,0,1,1.072-.088,3.286,3.286,0,0,0,2.292-.343q.3-.158.322-.792a.293.293,0,0,1,.095-.214q.158-.151.077-.27a.113.113,0,0,1-.018-.088.072.072,0,0,1,.053-.056q.6-.133.158-.266a2.579,2.579,0,0,0-.715-2.7,7.352,7.352,0,0,1,.575-1.549,1.326,1.326,0,0,0,.119-.887.387.387,0,0,1,.063-.308,19.467,19.467,0,0,0,1.952-2.961q1.139-2.117,2.232-4.261.543-1.065.873-1.843.55-1.307.852-1.85.771-1.391,1.71-3.094a.936.936,0,0,0-.056-1.055q-.456-.659-.841.109a35.5,35.5,0,0,0-1.6,3.718.461.461,0,0,1-.228.217l-.364.186L427,121.1a.471.471,0,0,0,0-.329Q424.851,114.725,431.1,112.98Zm-1.037,1.57a1.371,1.371,0,0,0-.978.715q-.571.273-.249.61a.645.645,0,0,0,.448.179,3.157,3.157,0,0,0,.515-.014q.308.266-.06,1.5a.4.4,0,0,0,.382.508h3.862a.205.205,0,0,0,.207-.168,1.631,1.631,0,0,0-.908-1.976,3.23,3.23,0,0,0-2.267-.07.2.2,0,0,1-.252-.1.466.466,0,0,1,0-.277.981.981,0,0,0,.273-.732.209.209,0,0,0-.172-.214A1.414,1.414,0,0,0,430.062,114.55Zm2.358,32.27q-.3,1.076.543,1.083.652,0,.852.018.75.042.806-.585a1.263,1.263,0,0,0-.224-.8,2.163,2.163,0,0,0-1.615-.981q-1.121-.151-.578.406A.883.883,0,0,1,432.42,146.82Z"
        transform="translate(-275.334 -112.951)"
        fill="#848ea9"
      />
      <path
        id="Path_28149"
        data-name="Path 28149"
        d="M472.55,113.608a5.466,5.466,0,0,1,2.817,1.941.637.637,0,0,1-.1.512,9.43,9.43,0,0,0-4.016-2.2A1.255,1.255,0,0,1,472.55,113.608Z"
        transform="translate(-314.77 -113.309)"
        fill="#848ea9"
      />
      <path
        id="Path_28150"
        data-name="Path 28150"
        d="M466.951,118.221l-.613.235a1.612,1.612,0,0,0,.41-.774.261.261,0,0,0-.105-.284.6.6,0,0,0-.392-.081,1.415,1.415,0,0,1,.8-.042.208.208,0,0,1,.172.214A.981.981,0,0,1,466.951,118.221Z"
        transform="translate(-311.521 -115.718)"
        fill="#848ea9"
      />
      <path
        id="Path_28151"
        data-name="Path 28151"
        d="M464.438,117.451a.6.6,0,0,1,.392.081.261.261,0,0,1,.105.284,1.613,1.613,0,0,1-.41.774l-.175.028q-.736.161-.89-.452A1.371,1.371,0,0,1,464.438,117.451Z"
        transform="translate(-309.709 -115.853)"
        fill="#848ea9"
      />
      <path
        id="Path_28152"
        data-name="Path 28152"
        d="M482.812,119.29a1.536,1.536,0,0,1,.438.76.428.428,0,0,1-.54-.249A.636.636,0,0,0,482.812,119.29Z"
        transform="translate(-322.214 -117.05)"
        fill="#848ea9"
      />
      <path
        id="Path_28153"
        data-name="Path 28153"
        d="M462.783,119.5q.154.613.89.452l-.175.322a3.156,3.156,0,0,1-.515.014.645.645,0,0,1-.449-.179Q462.212,119.773,462.783,119.5Z"
        transform="translate(-309.033 -117.186)"
        fill="#848ea9"
      />
      <path
        id="Path_28154"
        data-name="Path 28154"
        d="M466.323,120.04a.465.465,0,0,0,0,.277.2.2,0,0,0,.252.1,3.23,3.23,0,0,1,2.267.07,1.631,1.631,0,0,1,.908,1.976.205.205,0,0,1-.207.168h-3.862a.4.4,0,0,1-.382-.508q.368-1.23.06-1.5l.175-.322.175-.028Z"
        transform="translate(-310.895 -117.537)"
        fill="#848ea9"
      />
      <path
        id="Path_28155"
        data-name="Path 28155"
        d="M386.856,156.924a5.608,5.608,0,0,0-4.359.123.57.57,0,0,0-.256.224,2.984,2.984,0,0,0-.378,2.176.216.216,0,0,0,.214.175l5.495,0q.445.133-.158.266a.072.072,0,0,0-.053.056.113.113,0,0,0,.018.088q.081.119-.077.27a.293.293,0,0,0-.095.214q-.018.634-.322.792a3.286,3.286,0,0,1-2.292.343,1.6,1.6,0,0,0-1.072.088q-.179.088.017.056a3.755,3.755,0,0,1,1.5.07q.3.077.165.214a.378.378,0,0,1-.242.074.807.807,0,0,1-.242-.028,4.349,4.349,0,0,0-2.926.4,3.927,3.927,0,0,1-2.039.308q-.039,0-.823,0a1.57,1.57,0,0,1-1.153-.487,7.18,7.18,0,0,1-.1-4.92.214.214,0,0,0-.1-.259,39.491,39.491,0,0,0-9.857-3.7.8.8,0,0,0-.508.053,5.152,5.152,0,0,1-2.071.494,4.889,4.889,0,0,1-2.036-.4,4.632,4.632,0,0,1-2.576-2.5,4.876,4.876,0,0,1-.077-3.816,4.774,4.774,0,0,1,3.1-2.835,4.459,4.459,0,0,1,3.6.284,3.541,3.541,0,0,0-1.531-.179q-.578.06-.035.266a9.167,9.167,0,0,1,3.161,1.98.341.341,0,0,0,.249.109.139.139,0,0,0,.13-.1.389.389,0,0,0-.137-.291.951.951,0,0,1-.245-.547,4.507,4.507,0,0,1,1.212,3.14,3.634,3.634,0,0,0-.753-.547q-.785-.34-.529.049a1.268,1.268,0,0,0,.21.231,41.481,41.481,0,0,0,6.486,4.815l2.838,1.535a.675.675,0,0,0,.8-.1,7.28,7.28,0,0,1,7.257-2.131h-2.106q-.249,0-.046.144a3.561,3.561,0,0,0,2.05.732q.049.322.252.242a.374.374,0,0,0,.172-.189q.119-.235.259-.456a.176.176,0,0,0,.022-.136.13.13,0,0,0-.082-.092l-.259-.084-.263-.161a.858.858,0,0,0,1.16-.417,70.217,70.217,0,0,0,4.724-9.22l.364-.186a.461.461,0,0,0,.228-.217,35.5,35.5,0,0,1,1.6-3.718q.385-.767.841-.109a.936.936,0,0,1,.056,1.055q-.939,1.7-1.71,3.094-.3.543-.852,1.85-.329.778-.873,1.843-1.093,2.145-2.232,4.261a19.471,19.471,0,0,1-1.952,2.961.387.387,0,0,0-.063.308,1.326,1.326,0,0,1-.119.887A7.353,7.353,0,0,0,386.856,156.924ZM362.6,146.25q-.943.827.35.848a.467.467,0,0,1,.294.084.278.278,0,0,1,.091.3l-.217.88q-.172.708.564.7l3.143-.046a.437.437,0,0,0,.309-.13.348.348,0,0,0,.1-.294,1.816,1.816,0,0,0-2.05-1.668q-.431,0-.862.018-.361.018-.245-.438a1.449,1.449,0,0,0,.319-.68.177.177,0,0,0-.029-.135.184.184,0,0,0-.118-.075A1.6,1.6,0,0,0,362.6,146.25Zm15.226,9.262a37.514,37.514,0,0,0-4.177-2.152,15.7,15.7,0,0,1-2.625-1.43q-1.514-1.048-3.038-2.078-1.2-.813-1.055.435a.347.347,0,0,0,.186.259q2.842,1.486,5.8,2.737a17.827,17.827,0,0,1,2.362,1.212q1.135.694,2.281,1.367a1.481,1.481,0,0,0,.28.126q.964.326.231-.3A1.641,1.641,0,0,0,377.829,155.512Zm2.831.357q-.343.585.028.922a.846.846,0,0,0,.725.161,2.739,2.739,0,0,0,2.194-1.714c.053-.117-.118-.343-.4-.526a1.045,1.045,0,0,0-.964-.137A2.829,2.829,0,0,0,380.661,155.87Z"
        transform="translate(-242.567 -129.73)"
        fill="#848ea9"
      />
      <path
        id="Path_28156"
        data-name="Path 28156"
        d="M376.819,155.383l1.591,1.24a.951.951,0,0,0,.245.547.39.39,0,0,1,.137.291.139.139,0,0,1-.13.1.341.341,0,0,1-.249-.109,9.168,9.168,0,0,0-3.161-1.98q-.543-.207.035-.266A3.542,3.542,0,0,1,376.819,155.383Z"
        transform="translate(-252.24 -140.367)"
        fill="#848ea9"
      />
      <path
        id="Path_28157"
        data-name="Path 28157"
        d="M368.725,159.045l-.95.277a.567.567,0,0,1-.526-.526,1.6,1.6,0,0,1,1.647-.641.184.184,0,0,1,.118.075.177.177,0,0,1,.029.135A1.449,1.449,0,0,1,368.725,159.045Z"
        transform="translate(-247.214 -142.276)"
        fill="#848ea9"
      />
      <path
        id="Path_28158"
        data-name="Path 28158"
        d="M366.513,160.04a.567.567,0,0,0,.526.526l-.175.322Q365.571,160.867,366.513,160.04Z"
        transform="translate(-246.477 -143.52)"
        fill="#848ea9"
      />
      <path
        id="Path_28159"
        data-name="Path 28159"
        d="M369.375,160.75q-.116.456.245.438.431-.018.862-.018a1.815,1.815,0,0,1,2.05,1.668.348.348,0,0,1-.1.294.437.437,0,0,1-.309.13l-3.143.046q-.736.011-.564-.7l.217-.88a.278.278,0,0,0-.091-.3.467.467,0,0,0-.294-.084l.175-.322Z"
        transform="translate(-247.863 -143.981)"
        fill="#848ea9"
      />
      <path
        id="Path_28160"
        data-name="Path 28160"
        d="M385.716,166.943l5.414,4.548a41.481,41.481,0,0,1-6.486-4.815,1.267,1.267,0,0,1-.21-.231q-.256-.389.529-.049A3.633,3.633,0,0,1,385.716,166.943Z"
        transform="translate(-258.335 -147.546)"
        fill="#848ea9"
      />
      <path
        id="Path_28161"
        data-name="Path 28161"
        d="M390.717,175.556q.732.631-.231.3a1.482,1.482,0,0,1-.28-.126q-1.146-.673-2.281-1.367a17.823,17.823,0,0,0-2.362-1.212q-2.954-1.251-5.8-2.737a.347.347,0,0,1-.186-.259q-.147-1.247,1.055-.435,1.524,1.03,3.038,2.078a15.7,15.7,0,0,0,2.625,1.43,37.517,37.517,0,0,1,4.177,2.152A1.644,1.644,0,0,1,390.717,175.556Z"
        transform="translate(-255.213 -149.603)"
        fill="#848ea9"
      />
      <path
        id="Path_28162"
        data-name="Path 28162"
        d="M430.592,179.25l.263.161q-1.517-.011-.364.715a3.561,3.561,0,0,1-2.05-.732q-.2-.144.046-.144Z"
        transform="translate(-286.902 -155.999)"
        fill="#848ea9"
      />
      <path
        id="Path_28163"
        data-name="Path 28163"
        d="M433.9,179.71l.259.084a.13.13,0,0,1,.082.092.176.176,0,0,1-.022.136q-.14.221-.259.456a.374.374,0,0,1-.172.189q-.2.081-.252-.242Q432.384,179.7,433.9,179.71Z"
        transform="translate(-289.949 -156.297)"
        fill="#848ea9"
      />
      <path
        id="Path_28164"
        data-name="Path 28164"
        d="M418.474,184.979a2.829,2.829,0,0,1,1.587-1.293,1.045,1.045,0,0,1,.964.137c.278.182.449.409.4.526a2.739,2.739,0,0,1-2.194,1.714.846.846,0,0,1-.725-.161Q418.131,185.564,418.474,184.979Zm1.868-.894q-1.461.308-1.332,1.093a.371.371,0,0,0,.536.27q1.409-.722,1.332-1.027A.456.456,0,0,0,420.342,184.086Z"
        transform="translate(-280.381 -158.84)"
        fill="#848ea9"
      />
      <path
        id="Path_28165"
        data-name="Path 28165"
        d="M441.46,183.71l.088.028a7.686,7.686,0,0,0,1.142,1.777.236.236,0,0,1,.074.165.15.15,0,0,1-.067.1.182.182,0,0,1-.2-.007,4.834,4.834,0,0,1-1.034-.764,4.311,4.311,0,0,0-.561-.431Q440.149,184.071,441.46,183.71Z"
        transform="translate(-294.879 -158.896)"
        fill="#848ea9"
      />
      <path
        id="Path_28166"
        data-name="Path 28166"
        d="M421.622,184.922a.456.456,0,0,1,.536.336q.077.3-1.332,1.027a.371.371,0,0,1-.536-.27Q420.161,185.23,421.622,184.922Z"
        transform="translate(-281.66 -159.676)"
        fill="#848ea9"
      />
      <path
        id="Path_28167"
        data-name="Path 28167"
        d="M427.088,189.793a2.58,2.58,0,0,1,.715,2.7l-5.495,0a.216.216,0,0,1-.214-.175,2.984,2.984,0,0,1,.378-2.176.57.57,0,0,1,.256-.224A5.608,5.608,0,0,1,427.088,189.793Z"
        transform="translate(-282.799 -162.599)"
        fill="#848ea9"
      />
      <path
        id="Path_28168"
        data-name="Path 28168"
        d="M49.8,211.468a.431.431,0,0,0-.063.575l-.007,13.386a.172.172,0,0,1-.172.172l-6.287.021a.18.18,0,0,1-.179-.182v-10.32a.273.273,0,0,0-.273-.273H31.864a.333.333,0,0,0-.333.333v10.26a.182.182,0,0,1-.182.182H25.192a.231.231,0,0,1-.231-.231l-.021-27.652a.241.241,0,0,1,.067-.167.219.219,0,0,1,.161-.068l6.122.056a.18.18,0,0,1,.179.182l.06,10.2a.322.322,0,0,0,.319.326l11.094-.06a.177.177,0,0,0,.175-.179l-.021-10.3a.231.231,0,0,1,.231-.231l6.178.021a.254.254,0,0,1,.252.252Z"
        transform="translate(-24.855 -167.854)"
        fill="#848ea9"
      />
      <path
        id="Path_28169"
        data-name="Path 28169"
        d="M95.56,212.042a.431.431,0,0,1,.063-.575l13.8-13.75a.719.719,0,0,1,.512-.217l8.641.021q.368,0,.109.263L105.007,211.5a.144.144,0,0,0,0,.2l13.7,13.7q.21.214-.088.214h-8.554a1.248,1.248,0,0,1-.887-.368L95.865,211.9c-.1-.095-.216-.131-.266-.081A.263.263,0,0,0,95.56,212.042Z"
        transform="translate(-70.676 -167.854)"
        fill="#848ea9"
      />
      <path
        id="Path_28170"
        data-name="Path 28170"
        d="M185.834,218.4a2.017,2.017,0,0,0-.347-3.115,2.838,2.838,0,0,0-1.931-.487l-.83.028h-5.365a9.288,9.288,0,0,1-4.527-1,8.461,8.461,0,0,1-3.935-4.352,8.806,8.806,0,0,1-.557-4.272A8.159,8.159,0,0,1,170,201.074a8.994,8.994,0,0,1,3.48-2.737,9.72,9.72,0,0,1,4.5-.855q2.8.119,4.731.084,4.643-.084,9.409-.084a.77.77,0,0,1,.862.8,32.993,32.993,0,0,1-.035,5.249.643.643,0,0,1-.638.592q-7.594.039-15.2.014a2.336,2.336,0,0,0-1.4.421,1.862,1.862,0,0,0-.708,1.156,1.756,1.756,0,0,0,1.1,2.327,7.39,7.39,0,0,0,2.215.221H182.1l1.219-.032a9.851,9.851,0,0,1,5.7,1.521,8.407,8.407,0,0,1,3.262,3.806,8.6,8.6,0,0,1-3.248,10.66,7.425,7.425,0,0,1-4.219,1.325q-8.049.084-15.846.046a.632.632,0,0,1-.711-.715v-5.109a.636.636,0,0,1,.445-.606,5.323,5.323,0,0,1,1.658-.2q7.215.1,14.28.06A1.429,1.429,0,0,0,185.834,218.4Z"
        transform="translate(-117.947 -167.835)"
        fill="#848ea9"
      />
      <path
        id="Path_28171"
        data-name="Path 28171"
        d="M257.242,204.351a.361.361,0,0,0-.319-.193h-7.366q-1.262,0-1.177-1.118.039-.533.039-.575v-3.827q0-1.128.964-1.128,11.389-.011,22.83-.01a.805.805,0,0,1,.911.911V203.4a.672.672,0,0,1-.76.76h-7.415a.75.75,0,0,0-.852.841l-.081,19.96a.586.586,0,0,1-.659.662h-5.193a.62.62,0,0,1-.7-.7q-.039-9.468-.021-19.168,0-.035.021-.389A1.905,1.905,0,0,0,257.242,204.351Z"
        transform="translate(-169.994 -167.854)"
        fill="#848ea9"
      />
      <path
        id="Path_28172"
        data-name="Path 28172"
        d="M329.069,225.562a.751.751,0,0,1-.809-.845l.081-26.306a.82.82,0,0,1,.95-.922q7.769.144,15.348.091a7.384,7.384,0,0,1,3.837,1.065,9.843,9.843,0,0,1,2.873,2.6,7.825,7.825,0,0,1,1.342,7.306,8.759,8.759,0,0,1-2.635,4.226,8.451,8.451,0,0,1-3.1,1.707,12.358,12.358,0,0,1-3.452.34q-3.995-.021-7.828.1a.7.7,0,0,0-.764.788v8.855q0,1.149-1.023,1.09-.547-.035-.582-.032Q331.049,225.656,329.069,225.562Zm5.894-20.748.007,2.838q0,.617.694.617H343.9a3.887,3.887,0,0,0,1.286-.158,1.713,1.713,0,0,0,1.009-.915,1.89,1.89,0,0,0-.41-2.534,3.612,3.612,0,0,0-2.1-.5q-3.991-.028-7.983-.014Q334.964,204.154,334.964,204.813Z"
        transform="translate(-221.887 -167.846)"
        fill="#848ea9"
      />
      <path
        id="Path_28173"
        data-name="Path 28173"
        d="M472.759,199.21a5.146,5.146,0,0,1,3.066,2.131q-.256.417-.55.067a1.594,1.594,0,0,0-.322-.319,15.975,15.975,0,0,0-3.431-1.717q-.217-.081.007-.091Z"
        transform="translate(-314.877 -168.964)"
        fill="#848ea9"
      />
      <path
        id="Path_28174"
        data-name="Path 28174"
        d="M449.49,202.58l3.157.336a11.5,11.5,0,0,0,2.334.168q.042,0,.406.032a.507.507,0,0,0,.512-.235.511.511,0,0,1,.953.21q-1.552-.133-.1.424.221.533-.336.333a1.11,1.11,0,0,0-.364-.07A18.6,18.6,0,0,1,449.49,202.58Z"
        transform="translate(-300.635 -171.153)"
        fill="#848ea9"
      />
      <path
        id="Path_28175"
        data-name="Path 28175"
        d="M469.012,203.992l-.1.424Q467.46,203.859,469.012,203.992Z"
        transform="translate(-312.795 -172.054)"
        fill="#848ea9"
      />
      <path
        id="Path_28176"
        data-name="Path 28176"
        d="M472.249,207.146a.883.883,0,0,0-.217-.859q-.543-.557.578-.406a2.163,2.163,0,0,1,1.615.981,1.263,1.263,0,0,1,.224.8q-.056.627-.806.585-.2-.014-.852-.018Q471.944,208.221,472.249,207.146Z"
        transform="translate(-315.162 -173.276)"
        fill="#848ea9"
      />
      <path
        id="Path_28177"
        data-name="Path 28177"
        d="M429.733,230.52q-.838.519-.809-.182a121,121,0,0,0-.14-12.857l0-2.541a.534.534,0,0,1,.088-.322q.291-.378.284.5a22.591,22.591,0,0,0,.133,2.7q.2,1.8.221,2.681l.105,4.321q0,.14-.067,2.849A15.848,15.848,0,0,0,429.733,230.52Z"
        transform="translate(-287.182 -178.899)"
        fill="#848ea9"
      />
      <path
        id="Path_28178"
        data-name="Path 28178"
        d="M421.643,223a120.987,120.987,0,0,1,.14,12.857q-.028.7.809.182l1.945.105q.7.375.785-.091h.06l.378.788-.014.161q-.6-.238-1.205-.47a.372.372,0,0,0-.224-.025.5.5,0,0,0-.214.105.152.152,0,0,0-.047.131.16.16,0,0,0,.079.118l2.05,1.219a2.607,2.607,0,0,0,.722.666q.452.14.308-.308a1.714,1.714,0,0,0-.68-.8.742.742,0,0,1-.175-.263l.175-.028a4.92,4.92,0,0,1,1.906,4.373,5.049,5.049,0,0,1-3.252,4.552,5.376,5.376,0,0,1-3.192.291,5.079,5.079,0,0,1-2.908-1.717,5.358,5.358,0,0,1-1.283-3.995,5.169,5.169,0,0,1,2.26-3.848.447.447,0,0,0,.172-.277,67.14,67.14,0,0,0,1.114-11.806Zm-.627,16.368q.564.063.109,1.458a.454.454,0,0,0,.052.39.461.461,0,0,0,.337.206,19.97,19.97,0,0,0,3.883-.007.221.221,0,0,0,.2-.189,1.806,1.806,0,0,0-.442-1.535,2.154,2.154,0,0,0-1.447-.61,3.794,3.794,0,0,0-1.633.231q-.375.137-.357-.266a1.293,1.293,0,0,0,.7-.627q.449-.876-.459-.855a1.818,1.818,0,0,0-1.724,1.065.436.436,0,0,0-.028.333A.619.619,0,0,0,421.016,239.368Z"
        transform="translate(-280.042 -184.417)"
        fill="#848ea9"
      />
      <path
        id="Path_28179"
        data-name="Path 28179"
        d="M434.708,241l.9,4.731a4.1,4.1,0,0,0,.438,2.015q-.084.466-.785.091l-.96-6.486a.23.23,0,0,1,.14-.252Z"
        transform="translate(-290.77 -196.11)"
        fill="#848ea9"
      />
      <path
        id="Path_28180"
        data-name="Path 28180"
        d="M438.035,254.5l.5,2.015h-.06A4.1,4.1,0,0,1,438.035,254.5Z"
        transform="translate(-293.191 -204.879)"
        fill="#848ea9"
      />
      <path
        id="Path_28181"
        data-name="Path 28181"
        d="M437.364,262.029l.613.378a.742.742,0,0,0,.175.263q.084.459-.35.438l-2.05-1.219a.16.16,0,0,1-.079-.118.152.152,0,0,1,.047-.131.5.5,0,0,1,.214-.105.372.372,0,0,1,.224.025Q436.761,261.791,437.364,262.029Z"
        transform="translate(-291.659 -209.443)"
        fill="#848ea9"
      />
      <path
        id="Path_28182"
        data-name="Path 28182"
        d="M440.514,262.5a1.724,1.724,0,0,1,.774.512l-.175.028-.613-.378Z"
        transform="translate(-294.795 -210.076)"
        fill="#848ea9"
      />
      <path
        id="Path_28183"
        data-name="Path 28183"
        d="M426.161,266.041l-.7.322a.619.619,0,0,1-.81-.406.435.435,0,0,1,.028-.333,1.817,1.817,0,0,1,1.724-1.065q.908-.021.459.855A1.293,1.293,0,0,1,426.161,266.041Zm-.508-.151a.385.385,0,0,0,.333-.116q.873-.953-.06-.915a.631.631,0,0,0-.5.228.971.971,0,0,0-.214.568.2.2,0,0,0,.175.2Z"
        transform="translate(-284.486 -211.413)"
        fill="#848ea9"
      />
      <path
        id="Path_28184"
        data-name="Path 28184"
        d="M442.1,264.79a1.714,1.714,0,0,1,.68.8q.144.449-.308.308a2.607,2.607,0,0,1-.722-.666Q442.185,265.249,442.1,264.79Z"
        transform="translate(-295.607 -211.563)"
        fill="#848ea9"
      />
      <path
        id="Path_28185"
        data-name="Path 28185"
        d="M426.738,266.447l-.263-.035a.2.2,0,0,1-.175-.2.971.971,0,0,1,.214-.568.631.631,0,0,1,.5-.228q.932-.039.06.915A.385.385,0,0,1,426.738,266.447Z"
        transform="translate(-285.571 -211.97)"
        fill="#848ea9"
      />
      <path
        id="Path_28186"
        data-name="Path 28186"
        d="M427.7,268.79q-.017.4.357.266a3.794,3.794,0,0,1,1.633-.231,2.154,2.154,0,0,1,1.447.61,1.806,1.806,0,0,1,.442,1.535.221.221,0,0,1-.2.189,19.965,19.965,0,0,1-3.883.007.461.461,0,0,1-.338-.206.454.454,0,0,1-.051-.39q.455-1.395-.109-1.458Z"
        transform="translate(-286.025 -214.162)"
        fill="#848ea9"
      />
      <path
        id="Path_28187"
        data-name="Path 28187"
        d="M35.075,294.073l-.042,4.075a.175.175,0,0,1-.175.175l-9.192.021a.238.238,0,0,1-.238-.266,15.5,15.5,0,0,0,.007-3.325.8.8,0,0,1,.053-.34q.224-.624-.484-.578a.249.249,0,0,1-.259-.137.688.688,0,0,1,.06-.61c.146-.262.3-.45.371-.459A4.272,4.272,0,0,0,27.8,291.41q.287-.291-.123-.273-1.023.039-1.973.028-.042,0-.389.025-.816.056-.452-1.083a.25.25,0,0,1,.238-.172l4.152-.018a.293.293,0,0,0,.259-.161q.336-.687-.508-.638-.48.028-.515.028-1.535,0-3.066,0a.3.3,0,0,1-.273-.147.818.818,0,0,1,0-.845.3.3,0,0,1,.27-.144,74.876,74.876,0,0,0,9.791-.4.214.214,0,0,1,.228.151q.291,1.058-.69,1.125l-.606.046a22.345,22.345,0,0,1-2.852.217.291.291,0,0,0-.263.147q-.35.683.613.641.859-.035,3.834.018a.252.252,0,0,1,.238.165,1.329,1.329,0,0,1,0,.862.249.249,0,0,1-.238.172l-2.695-.077q-.47-.014-.175.263a4.9,4.9,0,0,0,1.966,1.142,2.248,2.248,0,0,0,.624.039.477.477,0,0,1,.564.438,3.562,3.562,0,0,1,.039.617q-.014.41-.543.354a.162.162,0,0,0-.122.036.147.147,0,0,0-.053.111Zm-4.328-.957q-1.661.466-1.174-1.269a.353.353,0,0,0-.021-.312q-.1-.116-.256.088a5.157,5.157,0,0,1-2.544,1.749.232.232,0,0,0-.154.137.11.11,0,0,0,.026.115.167.167,0,0,0,.128.05q3.329-.116,6.654.035.354.018.435-.119a.118.118,0,0,0-.016-.125.294.294,0,0,0-.141-.1,5.915,5.915,0,0,1-2.47-1.724q-.249-.28-.259.095l-.035,1.156A.237.237,0,0,1,30.747,293.117Zm2.894,1.756a.3.3,0,0,0-.3-.3H27.2a.3.3,0,0,0-.3.3v.371a.3.3,0,0,0,.3.3h6.146a.3.3,0,0,0,.3-.3Zm-.007,1.9a.263.263,0,0,0-.263-.263h-6.2a.263.263,0,0,0-.263.263v.35a.263.263,0,0,0,.263.263h6.2a.263.263,0,0,0,.263-.263Z"
        transform="translate(-24.699 -226.385)"
        fill="#848ea9"
      />
      <path
        id="Path_28188"
        data-name="Path 28188"
        d="M214.251,295.582a5.254,5.254,0,0,0-.077,1.731q.2,1.244-.908.946a.279.279,0,0,1-.2-.217,6.984,6.984,0,0,1-.07-2.225.222.222,0,0,0-.057-.178.23.23,0,0,0-.174-.074q-1.363.039-2.8.165-.624.056-.631.053-.333-.081-.319-.739a.433.433,0,0,1,.4-.424l3.347-.284a.28.28,0,0,0,.263-.277l.021-6.269a.237.237,0,0,1,.186-.231q1.037-.228.978.48-.025.308-.025.333v5.221a.494.494,0,0,0,.487.494q1.43.025,1,.967a.319.319,0,0,1-.256.161l-.946.144A.264.264,0,0,0,214.251,295.582Z"
        transform="translate(-144.423 -226.316)"
        fill="#848ea9"
      />
      <path
        id="Path_28189"
        data-name="Path 28189"
        d="M285.538,289.2a.351.351,0,0,0,.156.287.375.375,0,0,0,.331.043q.585-.2.659.308.119.841-.757.7a.349.349,0,0,0-.279.079.341.341,0,0,0-.121.261v1.339q0,.491.421.231.806-.5.8.463,0,.666-.845.708a.38.38,0,0,0-.361.375q-.014,1.216-.032,2.548a1.661,1.661,0,0,1-.452,1.293,1.632,1.632,0,0,1-1.556.291.332.332,0,0,1-.238-.2,1.167,1.167,0,0,1-.046-.708.2.2,0,0,1,.224-.144q1.209.109,1.013-.9a5.2,5.2,0,0,1-.088-1.219q.056-1.205-.873-.76a.4.4,0,0,1-.543-.221q-.431-1.167.824-1.062a.559.559,0,0,0,.427-.146.566.566,0,0,0,.183-.415v-1.468a.34.34,0,0,0-.392-.336q-1.223.189-.876-.859a.222.222,0,0,1,.238-.137q1.353.172,1.083-1.286-.2-1.076.911-.69a.272.272,0,0,1,.179.259Z"
        transform="translate(-192.386 -226.289)"
        fill="#848ea9"
      />
      <path
        id="Path_28190"
        data-name="Path 28190"
        d="M295.678,295.565a13.206,13.206,0,0,1-1.941-3.353.378.378,0,0,1,.043-.355.394.394,0,0,1,.322-.167l1.685-.01a.415.415,0,0,0,.3-.137,1.088,1.088,0,0,0,.133-1.342.255.255,0,0,0-.259-.13q-.69.074-1.377.109-1.219.06-.834-1.016a.254.254,0,0,1,.238-.168l1.976-.035a.309.309,0,0,0,.27-.147,1.221,1.221,0,0,0,.077-.89.447.447,0,0,1,.056-.336.44.44,0,0,1,.277-.2q1.093-.256.8,1.006a.47.47,0,0,0,.093.4.494.494,0,0,0,.38.182l2.074.01a.313.313,0,0,1,.27.154.678.678,0,0,1-.063.82.368.368,0,0,1-.294.137l-2.152-.035a.233.233,0,0,0-.231.147q-.624,1.752,1.177,1.479,1.745-.266.974,1.419a9.122,9.122,0,0,1-1.549,2.383.405.405,0,0,0-.1.353.373.373,0,0,0,.226.275l1.927.792a.253.253,0,0,1,.168.231q0,.7-.533.767a1.605,1.605,0,0,1-.76-.168,13.594,13.594,0,0,1-1.882-.96.729.729,0,0,0-.676,0l-2.863,1.318a.3.3,0,0,1-.312-.049.722.722,0,0,1-.273-.83.327.327,0,0,1,.238-.2,6.22,6.22,0,0,0,2.369-1.2A.179.179,0,0,0,295.678,295.565Zm1.353-.694a5.581,5.581,0,0,0,1.307-1.7.361.361,0,0,0-.329-.512h-2.3q-.6,0-.284.466l1.184,1.724a.256.256,0,0,0,.2.106.3.3,0,0,0,.221-.082Z"
        transform="translate(-198.986 -226.216)"
        fill="#848ea9"
      />
      <path
        id="Path_28191"
        data-name="Path 28191"
        d="M378.581,297.771l-7.166-.021a.471.471,0,0,0-.308.116q-.161.137-.322.277a.641.641,0,0,1-.364.165q-.669.046-.669-.82v-9.752a.235.235,0,0,1,.235-.235l9.906.021a.177.177,0,0,1,.179.175l-.046,10.25a.269.269,0,0,1-.161.252.789.789,0,0,1-1.016-.284A.341.341,0,0,0,378.581,297.771Zm-7.114-6.777q-.154-.564.561-.543.964.025,1.931.028a.4.4,0,0,0,.3-.123q.4-.431-.389-.463-.7-.028-1.4-.046-.859-.018-.329-.662.224-.273,1.381-.021a.732.732,0,0,0,.922-.35.3.3,0,0,0-.277-.438h-2.877a.289.289,0,0,0-.294.284l0,7.927a.191.191,0,0,0,.182.189q3.252.172,6.507.105.035,0,.6.039.76.053.708-.7-.039-.592-.039-.61.067-3.5-.067-6.987a.2.2,0,0,0-.182-.189,24.664,24.664,0,0,0-2.562-.07q-1.314.031-.47.683a.54.54,0,0,0,.319.105l1.619.035a.257.257,0,0,1,.242.161q.2.561-.484.543t-1.388-.021a.59.59,0,0,0-.347.1q-.417.294.046.459a1.1,1.1,0,0,0,.406.046,11.924,11.924,0,0,1,2.141.095.3.3,0,0,1,.245.186q.144.428-.491.431-3.143.014-6.283-.021A.235.235,0,0,1,371.467,290.994Z"
        transform="translate(-248.838 -226.315)"
        fill="#848ea9"
      />
      <path
        id="Path_28192"
        data-name="Path 28192"
        d="M111.446,289.412a.38.38,0,0,1-.091-.032.194.194,0,0,1-.105-.137,2.319,2.319,0,0,1,.014-1.146.14.14,0,0,1,.081-.09.17.17,0,0,1,.13,0l1.647.659a.484.484,0,0,1,.263.2,1.819,1.819,0,0,1,.018,1.163.165.165,0,0,1-.214.116,12.165,12.165,0,0,1-1.566-.683A.63.63,0,0,0,111.446,289.412Z"
        transform="translate(-80.879 -226.637)"
        fill="#848ea9"
      />
      <path
        id="Path_28193"
        data-name="Path 28193"
        d="M120.9,288.171q-.172-.781,1.342-.382a.2.2,0,0,1,.147.224q-.074.5.347.484.3-.007.35,0a2.986,2.986,0,0,0,.946-.081.229.229,0,0,0,.165-.221q.028-.743,1.272-.4a.214.214,0,0,1,.158.238q-.095.655.617.459.953-.263.725,1.023a.256.256,0,0,1-.3.207q-1.388-.266-1,.852a.254.254,0,0,0,.238.168l1.184.035a.205.205,0,0,1,.2.179q.032.249.067.494.116.739-.971.463a.364.364,0,0,0-.449.421,1.047,1.047,0,0,0,.788.887.7.7,0,0,1,.508.571q.2,1.381-.676.7-.4-.308-.4.2l-.018,1.205a.184.184,0,0,1-.182.182l-4.184.018a.23.23,0,0,0-.228.2q-.137.96.417.89.3-.035.326-.035,1.668,0,3.34.049a1.647,1.647,0,0,0,.943-.21.354.354,0,0,1,.54.284,1.081,1.081,0,0,1-.165.718.856.856,0,0,1-.6.256,21.832,21.832,0,0,1-2.53.161,13.735,13.735,0,0,1-2.491-.105q-1.444-.445-1.16-2.81a.5.5,0,0,1,.5-.442l3.893-.025a.185.185,0,0,0,.193-.175v-.571a.192.192,0,0,0-.2-.179q-1.538-.028-3.077-.021a2.1,2.1,0,0,0-.939.21,9.418,9.418,0,0,0-.848.487.136.136,0,0,1-.131.013.127.127,0,0,1-.076-.1l-.105-.978a.392.392,0,0,1,.161-.259l1.237-1.086a.142.142,0,0,0,.044-.126.18.18,0,0,0-.079-.123.967.967,0,0,0-.929-.063.294.294,0,0,1-.4-.214q-.319-1.559,1.16-1.044a.3.3,0,0,0,.243-.021.307.307,0,0,0,.149-.2q.249-1.1-.806-.866a.364.364,0,0,1-.442-.3q-.182-1.195.8-.887a.3.3,0,0,0,.291-.064A.3.3,0,0,0,120.9,288.171Zm3.36,1.688a.165.165,0,0,0-.167-.163l-1.542.019a.165.165,0,0,0-.163.167l.009.715a.165.165,0,0,0,.167.163l1.542-.019a.165.165,0,0,0,.163-.167Zm-2.231,2.555q-.466.718.336.655.5-.039.575-.039h1.629a.25.25,0,0,0,.2-.1.193.193,0,0,0,.024-.2l-.266-.547a.341.341,0,0,0-.27-.168,5.749,5.749,0,0,0-2.043.046.136.136,0,0,0-.105.109A.9.9,0,0,1,122.029,292.415Z"
        transform="translate(-86.188 -226.416)"
        fill="#848ea9"
      />
      <path
        id="Path_28194"
        data-name="Path 28194"
        d="M198.226,295.7q-.235.459-.494.869-.284.445-.522-.025a1.1,1.1,0,0,1,.238-1.43,8.264,8.264,0,0,0,1.076-2.246.188.188,0,0,0-.095-.242,1.913,1.913,0,0,0-.936-.161.266.266,0,0,1-.263-.133q-.529-1.044,1.041-.946a.349.349,0,0,0,.361-.266q.343-1.482-.729-1.205a.4.4,0,0,1-.319-.039q-.634-.438-.056-.922a.551.551,0,0,1,.312-.116l3.112-.238a.334.334,0,0,1,.291.116.822.822,0,0,1,.123.806.221.221,0,0,1-.238.14q-1.717-.165-1.153,1.521a.257.257,0,0,0,.231.165l.88.06a.274.274,0,0,1,.235.193q.392,1.191-1.051.939a.25.25,0,0,0-.266.119.92.92,0,0,0-.046.809.224.224,0,0,0,.249.119.793.793,0,0,1,.781.333.844.844,0,0,0,.252.221q.655.361,0,.943a.473.473,0,0,1-.676-.046q-.526-.617-.564.189-.081,1.7-.081,3.333a.413.413,0,0,1-.322.4q-.964.224-.943-.585.035-1.29.039-2.579a.34.34,0,0,0-.077-.252.192.192,0,0,0-.245-.014A.38.38,0,0,0,198.226,295.7Z"
        transform="translate(-136.653 -227.028)"
        fill="#848ea9"
      />
      <rect
        id="Rectangle_6040"
        data-name="Rectangle 6040"
        width="2.565"
        height="1.114"
        rx="0.557"
        transform="matrix(0.779, 0.627, -0.627, 0.779, 66.228, 62.102)"
        fill="#848ea9"
      />
      <path
        id="Path_28195"
        data-name="Path 28195"
        d="M111.148,297.363a1.061,1.061,0,0,1,.088-.862.2.2,0,0,1,.249-.081l1.664.68a.306.306,0,0,1,.217.228l.067,1.107a.111.111,0,0,1-.058.1.16.16,0,0,1-.134.01q-.722-.252-1.419-.571A1.153,1.153,0,0,1,111.148,297.363Z"
        transform="translate(-80.819 -232.1)"
        fill="#848ea9"
      />
      <rect
        id="Rectangle_6041"
        data-name="Rectangle 6041"
        width="2.502"
        height="1.107"
        rx="0.554"
        transform="matrix(0.775, 0.632, -0.632, 0.775, 65.705, 64.902)"
        fill="#848ea9"
      />
      <path
        id="Path_28196"
        data-name="Path 28196"
        d="M380.917,301.7a.261.261,0,0,1-.438.028l-1.892.046a.684.684,0,0,0-.575.54q-.463,1.549.543,1.367a.631.631,0,0,1,.333.018q.732.277.046.568a1.24,1.24,0,0,1-.428.084,22.141,22.141,0,0,0-2.32.228.316.316,0,0,1-.294-.1q-.375-.463.47-.571.648-.084.364-.557a.248.248,0,0,0-.273-.105,3.983,3.983,0,0,0-.95.368,1.657,1.657,0,0,1-.645.245q-.477,0-.459-.589a.276.276,0,0,1,.172-.242q.7-.308,1.4-.627a.678.678,0,0,0,.322-.266q.21-.375-.456-.392-.252-.007-.5-.028a.244.244,0,0,1-.217-.186,3.337,3.337,0,0,1,0-1.549.217.217,0,0,1,.217-.172l5.256.042a.189.189,0,0,1,.186.179Zm-1.149-.97a.336.336,0,0,0-.337-.336l-2.9.005a.336.336,0,0,0-.336.337v.021a.336.336,0,0,0,.337.336l2.9-.005a.336.336,0,0,0,.336-.337Z"
        transform="translate(-251.856 -234.305)"
        fill="#848ea9"
      />
      <path
        id="Path_28197"
        data-name="Path 28197"
        d="M112.532,305.515a.366.366,0,0,1,.287-.3q1.111-.228.96.582-.091.5-.1.561a4.182,4.182,0,0,1-2.1,3.3q-.189.116-.189-.084v-1.409a.549.549,0,0,1,.158-.3A4.692,4.692,0,0,0,112.532,305.515Z"
        transform="translate(-81.012 -237.792)"
        fill="#848ea9"
      />
      <path
        id="Path_28198"
        data-name="Path 28198"
        d="M388.021,305.238a.261.261,0,0,0,.438-.028q.732.4.154.869-.662.529.007.778a.589.589,0,0,1,.28.189.39.39,0,0,1-.109.638.328.328,0,0,1-.315,0q-1.009-.487-2.022-.964a.774.774,0,0,1-.4-.35q-.165-.357.308-.5a.494.494,0,0,1,.329.039Q387.695,306.359,388.021,305.238Z"
        transform="translate(-259.398 -237.819)"
        fill="#848ea9"
      />
    </g>
  </Svg>
));

HKSTPLogoIcon.displayName = 'HKSTPLogoIcon';

export default HKSTPLogoIcon;
